import parsePhoneNumber from 'libphonenumber-js';

const formatPhoneNumber = (phoneNumber: string) => {
  try {
    return parsePhoneNumber(phoneNumber);
  } catch {
    return undefined;
  }
};

export { formatPhoneNumber };
